import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import ModalPrincipal from '../../components/ModalAlert/modal';
import Loading from '../../components/Loading';
import {FaMapMarkerAlt, FaCalendarAlt, FaTasks, FaRegClock,FaFileAlt
} from 'react-icons/fa';
import './index.css';
import { ImCheckboxChecked, ImCheckboxUnchecked } from 'react-icons/im';
import MapView from '../../components/MapView/MapView'
import ModalIncluirNovo2 from '../../components/ModalIncluirNovo2/modal'

interface Task {
    age_name: string;
    tsk_id: string;
    ast_description: string;
    loc_description: string;
    tsk_scheduleinitialdatehour: string | null;
    tsk_realinitialdatehour: string | null;
    tsk_realfinaldatehour: string | null;
    stn_description: string;
    src_description: string;
    tsk_observation: string;
    tty_description: string;
}

interface Item {
    act_displayorder: string;
    act_description: string;
    asf_description: string;
    htv_externalvalue: string;
    htv_internalvalue: string;
    age_name: string;
    hty_initialdatehour: string;
    hty_finaldatehour: string;
    fte_id: any;
    asf_displayorder: any;
    hty_syncdatehour: string;
    asf_typelist: any;
    asf_truevalue: string;
    asf_falsevalue: string;
    ite_description: string;
    act_id: number;
    ite_id: string;
    hty_id: string;
    fte_description: string;
    asf_id: string;
    act_mode: string;
    act_griditem: string;
}

type Params = {
    company?: string;
    token?: string;
    id?: string;
};

type HistoryItem = {
    hty_id: number;
    tsk_id: number;
    act_id: number;
    act_description: string;
    act_displayorder: string;
    act_mode: number;
    ite_description: string | null;
    asf_id: number;
    asf_description: string;
    asf_displayorder: number;
    fte_description: string;
    ite_id: number | null;
    htv_internalvalue: string | null;
    act_griditem: number;
};

type RawGroupedData = [string, HistoryItem[]];

type GroupedItem = {
    ite_description: string;
    fields: HistoryItem[];
};

type GroupedByActivity = {
    act_id: number;
    act_description: string;
    items: GroupedItem[];
};


function VisualizarTask() {
    const { company, token, id } = useParams<Params>();
    const navigate = useNavigate();

    // Estados para os dados da tarefa e itens agrupados
    const [taskData, setTaskData] = useState<Task | null>(null);
    const [groupedData, setGroupedData] = useState<Record<string, Item[]>>({});
    const [logo, setLogo] = useState<string | null>(null);
    const [tsk_realinitialdatehour, setTsk_realinitialdatehour] = useState<string | null>(null);
    const [openModal, setOpenModal] = useState(false);
    const [qualAlert, setQualAlert] = useState(<></>);
    const [openModalIncluirNovo2, setOpenModalIncluirNovo2] = useState(false)
    const [qualTitulo, setQualTitulo] = useState('')
    const [qualGrid, setQualGrid] = useState(<></>)
    const [atividadeAgrupada, setAtividadeAgrupada] = useState<any[]>([]);


    useEffect(() => {
        setQualAlert(<div className='div-alert'><Loading /></div>);
        setOpenModal(true);

        validarAmbiente();

    }, []);

    async function validarAmbiente() {
        try {
            const response = await axios.get('https://tudoapi.mobcode.com.br:3000/ambientes/validar', {
                params: { ambiente: company }
            });

            const endPoint = response.data.data[0]?.amb_endpointweb;
            if (!endPoint) throw new Error("Endpoint não encontrado.");

            const taskResponse = await axios.get(`${endPoint}task/report`, {
                params: { tsk_id: id, tsk_accesstoken: token }
            });

            const logoFromStorage = taskResponse.data.data.imagem[0]?.etp_logotipo as string | null;
            if (logoFromStorage) {
                const image = new Image();
                image.src = logoFromStorage;
                image.onload = () => setLogo(logoFromStorage);
                image.onerror = () => setLogo(null);
            }

            const task = taskResponse.data.data.task[0];
            setTaskData({
                age_name: task.age_name,
                tsk_id: task.tsk_id,
                ast_description: task.ast_description,
                loc_description: task.loc_description,
                tsk_scheduleinitialdatehour: formatDateTime(task.tsk_scheduleinitialdatehour),
                stn_description: task.stn_description,
                src_description: task.src_description,
                tsk_observation: task.tsk_observation,
                tsk_realinitialdatehour: task.tsk_realinitialdatehour,
                tsk_realfinaldatehour: task.tsk_realfinaldatehour,
                tty_description: task.tty_description,
            });

            if (task.tsk_realinitialdatehour !== null) {
                if (task.tsk_realfinaldatehour !== null) {
                    setTsk_realinitialdatehour(formatDateRange(task.tsk_realinitialdatehour, task.tsk_realfinaldatehour));
                } else {
                    setTsk_realinitialdatehour(formatDateTime(task.tsk_realinitialdatehour));
                }
            }

            const history: Item[] = taskResponse.data.data.history;

            // Agrupado por hty_id
            const agrupadoPorHtyId = history.reduce((acc: Record<string, Item[]>, item) => {
                const key = item.hty_id;
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(item);
                return acc;
            }, {});
            setGroupedData(agrupadoPorHtyId); // Se quiser usar agrupado por hty_id

            // Agrupado por produto e detalhe (grid)
            const agrupadoPorAtividade = agruparHistoricoCompleto(agrupadoPorHtyId);
            setAtividadeAgrupada(agrupadoPorAtividade); // <- Troque por seu state real


            setOpenModal(false);

        } catch (error) {

        }
    }



    function agruparHistoricoCompleto(data: Record<string, Item[]>) {
        const atividadesMap = new Map<string, any>();

        Object.values(data).flat().forEach(item => {
            const actKey = String(item.act_id);
            const iteKey = String(item.ite_id);

            // Se ainda não existe a atividade, crie um novo objeto base
            if (!atividadesMap.has(actKey)) {
                atividadesMap.set(actKey, {
                    act_id: item.act_id,
                    act_description: item.act_description,
                    act_displayorder: item.act_displayorder,
                    act_mode: item.act_mode,
                    act_griditem: item.act_griditem,
                    dados: [],
                    produtos: {} // SEMPRE inicializa os dois
                });
            }

            const atividade = atividadesMap.get(actKey);

            // Verifica se o item tem produto (ite_id)
            if (item.ite_id != null) {
                if (!atividade.produtos[iteKey]) {
                    atividade.produtos[iteKey] = {
                        ite_id: item.ite_id,
                        ite_description: item.ite_description,
                        dados: [],
                    };
                }
                atividade.produtos[iteKey].dados.push({
                    asf_id: item.asf_id,
                    asf_description: item.asf_description,
                    asf_displayorder: item.asf_displayorder,
                    htv_internalvalue: item.htv_internalvalue,
                    fte_description: item.fte_description,
                    fte_id: item.fte_id,
                    asf_typelist: item.asf_typelist,
                    asf_truevalue: item.asf_truevalue,
                    asf_falsevalue: item.asf_falsevalue,
                });
            } else {
                atividade.dados.push({
                    asf_id: item.asf_id,
                    asf_description: item.asf_description,
                    asf_displayorder: item.asf_displayorder,
                    htv_internalvalue: item.htv_internalvalue,
                    fte_description: item.fte_description,
                    fte_id: item.fte_id,
                    asf_typelist: item.asf_typelist,
                    asf_truevalue: item.asf_truevalue,
                    asf_falsevalue: item.asf_falsevalue,
                });
            }
        });

        // Converte produtos para array
        const resultado = Array.from(atividadesMap.values()).map(atividade => {
            if (atividade.produtos) {
                atividade.produtos = Object.values(atividade.produtos);
            }
            return atividade;
        });

        return resultado.sort((a, b) => parseInt(a.act_displayorder) - parseInt(b.act_displayorder));
    }





    function formatDateTime(dateTime: string | null): string {
        return dateTime ? `${dateTime.substring(8, 10)}/${dateTime.substring(5, 7)}/${dateTime.substring(0, 4)} ${dateTime.substring(11, 16)}` : '';
    }

    function formatDateRange(start: string | null, end: string | null): string {
        if (start && end) {
            return `${formatDateTime(start)} - ${formatDateTime(end)}`;
        }
        return '';
    }

    function groupAndSortItems(items: Item[]): Record<string, Item[]> {
        const sortedData = items.sort((a, b) => parseInt(a.act_displayorder) - parseInt(b.act_displayorder));
        return sortedData.reduce<Record<string, Item[]>>((acc, item) => {
            if (!acc[item.act_description]) acc[item.act_description] = [];
            acc[item.act_description].push(item);
            return acc;
        }, {});
    }

    const formatExecution = (item: Item): string => {
        const initialDate = new Date(item.hty_initialdatehour);
        const finalDate = new Date(item.hty_finaldatehour);

        const formattedDate = initialDate.toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });

        const formattedInitialTime = initialDate.toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });

        const formattedFinalTime = finalDate.toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });

        return `${formattedDate} ${formattedInitialTime} - ${formattedFinalTime}`;
    }

    function formatDateTime2(dateTime: string | null): string {
        if (!dateTime) return '';

        const date = new Date(dateTime);
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Os meses começam em 0
        const year = date.getUTCFullYear();
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    }

    function fecharOpenModalIncluirNovo2() {
        setOpenModalIncluirNovo2(false)
    }

    function consultarGPS(dados: any, atividade: any) {


        let inf = [{
            tsk_id: taskData?.tsk_id,
            act_description: atividade,
            htv_internalvalue: dados,
            tsk_alternativeidentifier: token,
            age_name: taskData?.age_name,
            ativo: taskData?.ast_description || taskData?.loc_description
        }]

        setQualGrid(<MapView markersData={inf} />)

        setOpenModalIncluirNovo2(true)

    }

    function formatDateToBR(dateStr: string): string {
        if (!dateStr) return '';
        const [year, month, day] = dateStr.split('-');
        return `${day}/${month}/${year}`;
    }





    return (
        <div className="ordem-servico-container-principal">
            <div className="ordem-servico-container">
                <div className="container-report1">
                    <div id="content1">
                        {logo ? (
                            <img className="img-dash10" src={logo} alt="Logo" />
                        ) : null}
                    </div>
                </div>

                <div className='title-report'>
                    <h1 className='title-report-text'>Relatório de Tarefas</h1>
                </div>

                <section className="principal-section">
                    <div className="info-content">
                        <p><FaFileAlt className="icon" /> <strong className='inf-principal'> Tarefa:</strong> {taskData?.tsk_id}</p>
                        <p><FaFileAlt className="icon" /> <strong className='inf-principal'> Quem:</strong> {taskData?.age_name}</p>
                        <p><FaMapMarkerAlt className="icon" /> <strong>Onde:</strong> {taskData?.ast_description || taskData?.loc_description}</p>
                        <p><FaCalendarAlt className="icon" /> <strong>Quando (Previsto):</strong> {taskData?.tsk_scheduleinitialdatehour}</p>
                        <p><FaRegClock className="icon" /> <strong>Quando (Executado):</strong> {tsk_realinitialdatehour}</p>
                        <p><strong>Tipo de Tarefa:</strong> {taskData?.tty_description}</p>
                        <p><strong>Situação:</strong> {taskData?.stn_description}</p>
                        <p><strong>Origem:</strong> {taskData?.src_description}</p>
                        <p><strong>Observação:</strong> {taskData?.tsk_observation}</p>
                    </div>
                </section>


                {atividadeAgrupada.map((atividade, index) => (
                    <section key={index} className="revisao-section">

                        <div className="revisao-header">
                            <FaTasks className="icon" />
                            <h2>
                                {atividade.act_description}
                            </h2>
                        </div>

                        {/* Formulário - act_mode 1 */}
                        {atividade.act_mode === 1 && atividade.dados && (
                            <div className="revisao-details">
                                {atividade.dados.map((item: any, index: any) => (
                                    <div key={index}>

                                        {item.fte_id === 13 || item.fte_id === 7 ? (
                                            <>
                                                <p><strong>{item.asf_description}</strong></p>

                                                {item.htv_internalvalue && (
                                                    <>

                                                        <a href={item.htv_internalvalue} target="_blank" rel="noopener noreferrer">
                                                            <img
                                                                className="img-item-visualizacao"
                                                                src={item.htv_internalvalue}
                                                                alt={`Anexo ${index + 1}`}
                                                            />
                                                        </a>


                                                    </>
                                                )}
                                            </>
                                        ) : item.fte_id === 6 && item.asf_typelist === 2 ? (

                                            <div key={index}>
                                          
                                                <ul>
                                                {company === 'unimed' && !item.htv_internalvalue ? (
                                                      <>

    <p><strong>{item.asf_description}  <ImCheckboxChecked className="logico-icone" /> Conforme</strong></p>
 
    </>
) : (

    <>
    {/* Exibe a descrição */}
    <p><strong>{item.asf_description}</strong></p>

    {/* Caso padrão (mesmo comportamento que já tinha) */}
    {(item.htv_internalvalue ?? '')
      .split('&')
      .filter(Boolean)
      .map((subItem: string, subIndex: number) => (
        <li key={subIndex}>
          <ImCheckboxChecked className="logico-icone" /> {subItem.trim()}
        </li>
      ))}
  </>
)}

                                                </ul>

                                            </div>

                                        ) : item.fte_id === 3 ? (

                                            <div key={index}>
                                                <p><strong>{item.asf_description}</strong></p>
                                                <ul className="icone-logico-container">
                                                    <ul className="icone-logico">
                                                        {item.htv_internalvalue === item.asf_truevalue ? (
                                                            <ImCheckboxChecked className="logico-icone" />
                                                        ) : (
                                                            <ImCheckboxUnchecked className="logico-icone" />
                                                        )}
                                                        {item.asf_truevalue}
                                                    </ul>
                                                    <ul className="icone-logico">
                                                        {item.htv_internalvalue === item.asf_falsevalue ? (
                                                            <ImCheckboxChecked className="logico-icone" />
                                                        ) : (
                                                            <ImCheckboxUnchecked className="logico-icone" />
                                                        )}
                                                        {item.asf_falsevalue}
                                                    </ul>
                                                </ul>
                                            </div>

                                        ) : item.fte_id === 9 ? (

                                            <div key={index} className="geo-info">

                                                <div>
                                                    <strong>{item.asf_description}</strong> {item.htv_internalvalue}
                                                </div>

                                                {item.htv_internalvalue && (
                                                    <FaMapMarkerAlt className="geo-icon"
                                                        onClick={() => consultarGPS(item.htv_internalvalue, atividade.act_description)}
                                                    />
                                                )}

                                            </div>


                                        ) : item.fte_id === 4 ? (

                                            <p key={index}>
                                                <strong>{item.asf_description} </strong>
                                                {item.htv_internalvalue?.match(/^\d{4}-\d{2}-\d{2}$/)
                                                    ? formatDateToBR(item.htv_internalvalue)
                                                    : item.htv_internalvalue}
                                            </p>


                                        ) : (
                                            <p key={index}>
                                                <strong>{item.asf_description}</strong> {item.htv_internalvalue}
                                            </p>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Produtos - act_mode 2 */}
                        {(atividade.act_mode === 2 || atividade.act_mode === 3) && atividade.produtos && (

                            <>
                                {atividade.act_griditem === 1 ? (

                                    <div className="revisao-grid-table">
                                        <table >
                                            <thead>
                                                <tr key={index}>
                                                    <th>Descrição Item</th>
                                                    {atividade.produtos[0]?.dados.map((campo: any, idx: number) => (
                                                        <th key={idx}>{campo.asf_description}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {atividade.produtos.map((produto: any, pidx: number) => (
                                                    <tr key={`produto-${pidx}`}>
                                                        <td><strong>{produto.ite_description}</strong></td>
                                                        {produto.dados.map((campo: any, cidx: number) => (
                                                            <React.Fragment key={`campo-${pidx}-${cidx}`}>
                                                                {campo.fte_id === 6 && campo.asf_typelist === 2 ? (
                                                                    <td>
                                                                        {(campo.htv_internalvalue ?? '')
                                                                            .toString()
                                                                            .split('&')
                                                                            .filter(Boolean)
                                                                            .map((item: string) => item.trim())
                                                                            .join(', ') || ''}

                                                                    </td>
                                                                ) : campo.fte_id === 13 ? (
                                                                    <td>
                                                                        {campo.htv_internalvalue && (
                                                                            <div className="foto2-grid">
                                                                                <a href={campo.htv_internalvalue} target="_blank" rel="noopener noreferrer">
                                                                                    <img
                                                                                        className="img-item-visualizacao"
                                                                                        src={campo.htv_internalvalue}
                                                                                        alt={`Anexo ${index + 1}`}
                                                                                    />
                                                                                </a>

                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                ) : (
                                                                    <td>{campo.htv_internalvalue || ''}</td>
                                                                )}
                                                            </React.Fragment>
                                                        ))}
                                                    </tr>
                                                ))}

                                            </tbody>
                                        </table>
                                    </div>

                                ) : (
                                    <>
                                        <div className="revisao-details">
                                            {atividade.produtos.map((produto: any, pidx: number) => (
                                                <>

                                                    <p className='item-descricao-2' key={pidx}>
                                                        <strong>{produto.ite_description}</strong>
                                                    </p>

                                                    <div>
                                                        {produto.dados.map((campo: any, cidx: number) => (
                                                            <React.Fragment key={`campo-${pidx}-${cidx}`}>

                                                                {campo.fte_id === 13 || campo.fte_id === 7 ? (
                                                                    <React.Fragment key={`2campo-${pidx}-${cidx}`}>


                                                                        <p><strong>{campo.asf_description}</strong></p>

                                                                        {campo.htv_internalvalue && (
                                                                            <>

                                                                                <a href={campo.htv_internalvalue} target="_blank" rel="noopener noreferrer">
                                                                                    <img
                                                                                        className="img-item-visualizacao"
                                                                                        src={campo.htv_internalvalue}
                                                                                        alt={`Anexo ${index + 1}`}
                                                                                    />
                                                                                </a>


                                                                            </>
                                                                        )}




                                                                    </React.Fragment>
                                                                ) : campo.fte_id === 6 && campo.asf_typelist === 2 ? (
                                                                    <div key={index}>
                                                                        <p><strong>{campo.asf_description}</strong></p>
                                                                        <ul>
                                                                            <ul className="lista-sem-ponto">
                                                                                {(campo.htv_internalvalue ?? '')
                                                                                    .split('&')
                                                                                    .filter(Boolean)
                                                                                    .map((subItem: string, subIndex: number) => (
                                                                                        <ul key={subIndex} className="item-sem-ponto">
                                                                                            <ImCheckboxChecked className="logico-icone" /> {subItem.trim()}
                                                                                        </ul>
                                                                                    ))}
                                                                            </ul>

                                                                        </ul>
                                                                    </div>

                                                                ) : campo.fte_id === 3 ? (

                                                                    <div key={index}>
                                                                        <p><strong>{campo.asf_description}</strong></p>
                                                                        <ul className="icone-logico-container">
                                                                            <ul className="icone-logico">
                                                                                {campo.htv_internalvalue === campo.asf_truevalue ? (
                                                                                    <ImCheckboxChecked className="logico-icone" />
                                                                                ) : (
                                                                                    <ImCheckboxUnchecked className="logico-icone" />
                                                                                )}
                                                                                {campo.asf_truevalue}
                                                                            </ul>
                                                                            <ul className="icone-logico">
                                                                                {campo.htv_internalvalue === campo.asf_falsevalue ? (
                                                                                    <ImCheckboxChecked className="logico-icone" />
                                                                                ) : (
                                                                                    <ImCheckboxUnchecked className="logico-icone" />
                                                                                )}
                                                                                {campo.asf_falsevalue}
                                                                            </ul>
                                                                        </ul>
                                                                    </div>
                                                                ) : campo.fte_id === 9 ? (

                                                                    <div key={index} className="geo-info">
                                                                        <strong>{campo.asf_description}</strong> {campo.htv_internalvalue}
                                                                        {campo.htv_internalvalue && (
                                                                            <FaMapMarkerAlt className="geo-icon"
                                                                                onClick={() =>
                                                                                    consultarGPS(campo.htv_internalvalue, atividade.act_description)}
                                                                            />
                                                                        )}

                                                                    </div>

                                                                ) : campo.fte_id === 4 ? (

                                                                    <p key={index}>
                                                                        <strong>{campo.asf_description} </strong>
                                                                        {campo.htv_internalvalue?.match(/^\d{4}-\d{2}-\d{2}$/)
                                                                            ? formatDateToBR(campo.htv_internalvalue)
                                                                            : campo.htv_internalvalue}
                                                                    </p>

                                                                ) : (
                                                                    <p key={cidx}>
                                                                        <strong>{campo.asf_description}</strong> {campo.htv_internalvalue}
                                                                    </p>
                                                                )}




                                                            </React.Fragment>
                                                        ))}
                                                    </div>


                                                </>
                                            ))}

                                        </div>
                                    </>
                                )}

                            </>


                        )}

                    </section>
                ))}



            </div>

            <ModalPrincipal isOpen={openModal} setModalOpen={() => setOpenModal(!openModal)}>
                <div className='container-modal-alert'>
                    {qualAlert}
                </div>
            </ModalPrincipal>

            <ModalIncluirNovo2 isOpen={openModalIncluirNovo2} setModalOpen={() => setOpenModalIncluirNovo2(!openModalIncluirNovo2)}>
                <>
                    <div className='title-modal-incluir'>
                        <h1 className="modal-IncluirNovo-title">{qualTitulo}</h1>
                        <div onClick={fecharOpenModalIncluirNovo2}>
                            <button className="fa fa-times icone-modal-IncluirNovo" data-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>

                    {qualGrid}


                </>
            </ModalIncluirNovo2>
        </div>
    );
}

export default VisualizarTask;
